import { GlobalConfig } from 'ngx-toastr';

// Setting Global Options for Toastr
export const ngxToastrConfig = {
  timeOut: 10000,
  extendedTimeOut: 3000,
  positionClass: 'toast-top-right',
  tapToDismiss: false,
  closeButton: true
};
